
import {getToken} from '../adalConfig';

export const actionCreators = {

    // REQUEST_CONTACTS 
    requestContacts: () => async (dispatch, getState) => {       
        dispatch({ type: 'REQUEST_CONTACTS' });
        const headers = { Authorization: `Bearer ${getToken()}` };
        const url = `api/Contacts`;
        const response = await fetch(url, {headers});
        const contacts = await response.json();
        dispatch({ type: 'RECEIVE_CONTACTS', contacts });
    },
    // ADD_CONTACT
    addContact: (newContact) => async (dispatch, getState) => {
        const headers = { 'Authorization': `Bearer ${getToken()}`,
                            'Content-Type': 'application/json'     
                        };    
        const url = `api/Contacts`;
        const response = await fetch(url, {
            method: 'post',
            body: JSON.stringify(newContact),
            headers
        });
        const contact = await response.json();
        dispatch({ type: 'ADD_CONTACT', contact });
        return contact;
    },
    //EDIT_CONTACT
    editContact: (id, contact) => async (dispatch, getState) => {
        const headers = { Authorization: `Bearer ${getToken()}`,
                        'Content-Type': 'application/json' };     
        const url = `api/Contacts/${id}`;
        const response = await fetch(url, {
            method: 'put',
            body: JSON.stringify(contact),
            headers
        });
        const updates = contact;
        //await response.json();
        dispatch({ type: 'EDIT_CONTACT', id: contact.id, updates });
    } 
};




// WEBPACK FOOTER //
// ./src/actions/contacts.js